import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  store_ids: yup.array().min(1, "At least one store is required"),
  expenses: yup.array().of(
    yup.object().shape({
      name: yup.string().required("Expense name is required"),
      amount: yup.string().required("Amount is required"),
      category: yup.string().required("Category is required"),
      payment_method: yup.string().required("Required"),
      expense_date: yup.string().required("Date is required"),
      description: yup.string(),
      vat_rate: yup.number().required("VAT rate is required"),
    }),
  ),
});

export const useValidation = ({ ...params }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...params,
    },
  });
};
